// extracted by mini-css-extract-plugin
export default {"unknownHeatingCost":"wq56HSXtjQOGNK0Do_zx"};